import messages from './BtnRetour.json'
import store from './../../../../store.js'

export default {

  name: 'BtnRetour',

  i18n: messages,

  props: {
    value: String
  },

  data() {
    return {

    }
  },

  methods: {
    /**
     * retour en arrière
     */
    retour() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
